import { z } from 'zod';
import { GoogleAuthProvider, PhoneAuthProvider } from 'firebase/auth';
import { languageOptions } from '../../config/constants';
import { avatarIdSchema } from '../userProfileSchema';

export let currentUserResourceSchema = z.object({
  id: z.string(),
  handle: z.string().optional(),
  avatarId: avatarIdSchema.optional(),
  avatarBackgroundHex: z.string().nullable().optional(),
  isAdmin: z.boolean().optional(),
  prefersLeftHandMode: z.boolean().optional(),
  prefersLanguageKey: z
    .enum(
      Object.keys(languageOptions) as [
        keyof typeof languageOptions,
        ...(keyof typeof languageOptions)[],
      ],
    )
    .optional(),
  authProvider: z.enum([
    PhoneAuthProvider.PROVIDER_ID,
    GoogleAuthProvider.PROVIDER_ID,
  ]),
  consentedToNotificationForYears: z
    .record(z.string(), z.boolean().optional())
    .optional(),
  optedOutCommunication: z.boolean().optional(),
  letterboxdId: z.string().nullable().optional(),
  hiddenActivityKeys: z.record(z.string(), z.boolean()).optional(),
  handleViolation: z
    .object({
      originalHandle: z.string(),
    })
    .nullable()
    .optional(),
  spoilerDelayMs: z.number().optional(),
  ballotData: z
    .record(
      z.string(),
      z.object({
        isCompleted: z.boolean().optional(),
        isStarted: z.boolean().optional(),
      }),
    )
    .optional(),
});

export type CurrentUserResourceType = z.infer<typeof currentUserResourceSchema>;
